document.addEventListener("DOMContentLoaded", () => {
 CF.ready(() => {
  var $myForm = document.querySelector('form[data-cf-form="ewt9Wn"]');
  if ($myForm) {
   $myForm.addEventListener('cf:form_submitted', function (event) {
    var submissionData = event.detail.submissionData;
    const options = {
     method: 'POST',
     headers: { revision: '2024-06-15', 'content-type': 'application/json' },
     body: JSON.stringify({
      data: {
       type: 'subscription',
       attributes: {
        custom_source: 'Puzzle Search Form',
        profile: {
         data: {
          type: 'profile',
          attributes: {
           email: submissionData?.email,
           phone_number: submissionData?.phone,
           first_name: submissionData?.first_name,
           last_name: submissionData?.last_name
          }
         }
        }
       },
       relationships: { list: { data: { type: 'list', id: 'RvGz2W' } } }
      }
     })
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=QvLmCY', options)
     .then(response => response.json())
     .then(response => console.log(response))
     .catch(err => console.error(err));
   })
  }
 })
})